if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.modalArrows = this.querySelector("#product-media-modal--arrows");
        this.counter = this.querySelector("#product-media-modal--arrows span");
        this.totalItems = this.querySelector(
          ".product-media-modal__content",
        ).childElementCount;
        this.counter.innerHTML = `1/${this.totalItems}`;
        this.modalArrows.addEventListener(
          "click",
          this.modalArrowsEventHandler.bind(this),
        );
        this.querySelector('[role="document"]').addEventListener(
          "scroll",
          this.handleScroll.bind(this),
        );
        this.addEventListener("click", this.handleClickEvent.bind(this), true);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id",
          )}"])`,
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`,
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft =
          activeMedia.offsetLeft -
          container.clientWidth / 2 +
          activeMedia.clientWidth / 2;

        this.setActiveIndex(activeMedia.dataset.forloopIndex);
        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }

      modalArrowsEventHandler(event) {
        const btn = event.target.closest("button.product-media-modal--arrow");
        if (!btn) return;
        const { arrowAction } = btn.dataset;
        const activeSlide = this.querySelector(".global-media-settings.active");
        let activeIndex = parseInt(activeSlide.dataset.forloopIndex);
        let newActiveIndex =
          arrowAction === "next" ? activeIndex + 1 : activeIndex - 1;
        const newActiveSlide = this.querySelector(
          `.global-media-settings[data-forloop-index="${newActiveIndex}"]`,
        );
        if (!newActiveSlide) return;
        activeSlide.classList.remove("active");
        newActiveSlide.classList.add("active");
        newActiveSlide.scrollIntoView({ behavior: "smooth", inline: "center" });
      }

      handleScroll() {
        const container = this.querySelector('[role="document"]');
        const slides = this.querySelectorAll(".global-media-settings");

        let closestSlide = null;
        let closestDistance = Infinity;

        slides.forEach((slide) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const containerCenter =
            container.scrollLeft + container.offsetWidth / 2;
          const distance = Math.abs(containerCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestSlide = slide;
          }
        });

        if (closestSlide && !closestSlide.classList.contains("active")) {
          this.querySelector(".global-media-settings.active")?.classList.remove(
            "active",
          );
          closestSlide.classList.add("active");
          this.setActiveIndex(closestSlide.dataset.forloopIndex);
        }
      }

      setActiveIndex(index) {
        this.counter.innerHTML = `${parseInt(index)}/${this.totalItems}`;
      }

      // Returns the on-screen rectangle of the actually-visible media pixels,
      // accounting for object-fit: contain letterboxing. Falls back to the
      // element's full box when intrinsic dimensions aren't known yet.
      getVisibleMediaRect(el) {
        const box = el.getBoundingClientRect();
        let natW = 0;
        let natH = 0;
        if (el.tagName === "VIDEO") {
          natW = el.videoWidth;
          natH = el.videoHeight;
        } else if (el.tagName === "IMG") {
          natW = el.naturalWidth;
          natH = el.naturalHeight;
        }
        if (!natW || !natH || !box.width || !box.height) return box;
        const boxRatio = box.width / box.height;
        const natRatio = natW / natH;
        let w;
        let h;
        if (natRatio > boxRatio) {
          w = box.width;
          h = box.width / natRatio;
        } else {
          h = box.height;
          w = box.height * natRatio;
        }
        const left = box.left + (box.width - w) / 2;
        const top = box.top + (box.height - h) / 2;
        return { left, top, right: left + w, bottom: top + h };
      }

      handleClickEvent(event) {
        // Let the nav arrows and the close button behave normally.
        if (
          event.target.closest("#product-media-modal--arrows") ||
          event.target.closest(".product-media-modal__toggle")
        ) {
          return;
        }

        const activeMedia =
          this.querySelector(".product-media-modal__content > .active") ||
          this.querySelector(".product-media-modal__content > *");
        if (!activeMedia) return;

        // The visible media is the playing video/iframe once loaded, otherwise
        // the deferred-media poster image.
        const mediaEl =
          activeMedia.querySelector("video, iframe, model-viewer") ||
          activeMedia.querySelector(".deferred-media__poster img, img");
        if (!mediaEl) return;

        const rect = this.getVisibleMediaRect(mediaEl);
        const insideMedia =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;

        // Clicking the empty space around the media (backdrop / letterbox) closes
        // the modal. Clicking the media itself is left alone so the poster can
        // still load the video and the player controls keep working. Running in
        // the capture phase lets a backdrop click close without also triggering
        // the poster's play handler.
        if (!insideMedia) {
          event.preventDefault();
          event.stopPropagation();
          this.hide();
        }
      }
    },
  );
}
